import ModalHeader from './header';
import ModalBody from './body';
import ModalFooter from './footer';
import Modal from './index';

export { ModalHeader, ModalBody, ModalFooter, Modal };